import { X } from 'lucide-react';
import { AssistantChat } from './AssistantChat';
import { useAssistantUi } from './assistantUiStore';
import { useT } from '@/lib/i18n/useT';

/**
 * Caso 07 — Side drawer hosting the assistant chat. Renders nothing
 * when closed so React Query's kickoff effect inside `AssistantChat`
 * (cost-control gate) stays quiet.
 */
export function AssistantDrawer() {
  const t = useT();
  const open = useAssistantUi((s) => s.open);
  const setOpen = useAssistantUi((s) => s.setOpen);
  if (!open) return null;
  return (
    <div
      className="fixed inset-y-0 right-0 z-50 flex w-full max-w-md flex-col border-l border-[var(--color-border-default)] bg-[var(--color-bg-surface)] shadow-2xl print:hidden"
      role="dialog"
      aria-label={t('assistant.drawer.aria')}
    >
      <header className="flex items-center justify-between border-b border-[var(--color-border-subtle)] px-4 py-3">
        <span className="text-sm font-semibold">{t('assistant.title')}</span>
        <button
          type="button"
          onClick={() => setOpen(false)}
          aria-label={t('common.close')}
          className="rounded-md p-1 hover:bg-[var(--color-bg-elevated)]"
        >
          <X className="h-4 w-4" />
        </button>
      </header>
      <div className="flex-1 overflow-hidden">
        <AssistantChat open={open} />
      </div>
    </div>
  );
}
